/* eslint-disable */
import { createRouter, createWebHistory } from 'vue-router';
import { setPageTitle, titleFromSlug } from '@/services/pageTitle';

import HomePage from "@/pages/HomePage.vue";
import GroupPage from "@/pages/GroupPage.vue";
import ProductPage from "@/pages/ProductPage.vue";
import BasketPage from "@/pages/BasketPage.vue";
import CheckoutPage from "@/pages/CheckoutPage.vue";
import FAQPage from "@/pages/FAQPage.vue";
import SuccessPage from "@/pages/SuccessPage.vue";
import MyOrdersPage from "@/pages/MyOrdersPage.vue";
import StaffSuccessPage from "@/pages/StaffSuccessPage.vue";
import BillingPage from "@/pages/billingPage.vue";
import SuccessBalancePage from "@/pages/SuccessBalancePage.vue";
import ShutStore from "@/pages/ShutStore.vue";
import NotFoundPage from "@/pages/NotFoundPage.vue";

// Any URL no other route matches. Must be in both lists.
const notFoundRoute = { path: "/:pathMatch(.*)*", component: NotFoundPage, meta: { title: "Page not found" } }

// Ordering open: the full shop.
// meta.title is the page title; product and category pages replace it with the real name once loaded.
const openRoutes = [
   { path: "/products/:groupId/:productId", component: ProductPage, props: true, meta: { title: route => titleFromSlug(route.params.groupId) } },
   { path: "/products/:groupId", component: GroupPage, props: true, meta: { title: route => titleFromSlug(route.params.groupId) } },
   { path: "/basket", component: BasketPage, props: true, meta: { title: "Basket" } },
   { path: "/success/staff/:guid/:key", component: StaffSuccessPage, props: true, meta: { title: "Order Confirmed" } },
   { path: "/success", component: SuccessPage, props: true, meta: { title: "Order Confirmed" } },
   { path: "/balance-success", component: SuccessBalancePage, props: true, meta: { title: "Balance Paid" } },
   { path: "/my-order", component: MyOrdersPage, props: true, meta: { title: "My Order" } },
   { path: "/checkout", component: CheckoutPage, props: true, meta: { title: "Checkout" } },
   { path: "/FAQ", component: FAQPage, props: true, meta: { title: "FAQ" } },
   { path: "/payment/:guid", component: BillingPage, pros: true, meta: { title: "Pay your balance" } },
   { path: "/", component: HomePage },
   notFoundRoute,
]

// Ordering closed: existing orders, balance payments and the FAQ only.
const closedRoutes = [
    { path: "/my-order", component: MyOrdersPage, props: true, meta: { title: "My Order" } },
    { path: "/FAQ", component: FAQPage, props: true, meta: { title: "FAQ" } },
    { path: "/", component: ShutStore },
    { path: "/payment/:guid", component: BillingPage, pros: true, meta: { title: "Pay your balance" } },
    { path: "/balance-success", component: SuccessBalancePage, props: true, meta: { title: "Balance Paid" } },
    notFoundRoute,
]

// Closed unless the build sets VUE_APP_STORE_OPEN=true (see the scripts in package.json).
const routes = process.env.VUE_APP_STORE_OPEN === 'true' ? openRoutes : closedRoutes



const router = createRouter({
    history: createWebHistory(),
    routes
});

// Page titles (FE-118): set here for every route; a route without meta.title gets the site default.
router.afterEach((to) => {
    const title = to.meta && to.meta.title;
    setPageTitle(typeof title === 'function' ? title(to) : title);
});

export default router;
